import { render, staticRenderFns } from "./SplitterContentTransference.vue?vue&type=template&id=f3367b88"
import script from "./SplitterContentTransference.vue?vue&type=script&lang=js"
export * from "./SplitterContentTransference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports